<template>
  <div class="visualizer">
    <div class="p-1 rounded" style="height: 600px;">
        <!-- Visualization Section -->
        <div class="" v-show="vismode=='table'">
            <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                    <div class="input-group flex-nowrap p-1">
                        <p class="fs-3 text-white mt-1 fw-light w-100">Visualizer</p>
                    </div>
                </div>
                
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="input-group flex-nowrap">
                        <input type="text" class="bg-dark rounded text-white text-center fs-6 border-0 w-50 me-1" placeholder="Filter by Hostname, Alias or IP" v-model="searchWord">
                        <select class="btn btn-dark fs-6 text-white w-25 fw-light me-1 rounded" v-model="name_alias_ip_toggle">
                            <option value="hostname">Hostname</option>
                            <option value="alias">Alias</option>
                            <option value="ip">IP Address</option>
                        </select>
                        <button class="btn btn-dark fs-6 w-25 me-1" :disabled="gettingDevices" @click="getDevices">
                            <i class="fa-solid fa-xl fa-refresh" :class="{'fa-spin': gettingDevices}"></i>
                        </button>
                        <button class="btn btn-dark fs-6 w-25" title="Download all backups." :disabled="gettingBackupsZip" @click="getBackupsZip">
                            <i class="fa-solid fa-xl fa-cloud-arrow-down" :class="{'fa-beat': gettingBackupsZip}"></i>
                        </button>
                    </div>
                    <div>
                        <div class="tableFixHead mt-1" style="height: 480px;">
                            <table>
                                <thead>
                                    <tr>
                                        <th class="fw-light bg-black text-white fs-6 rounded" style="border-bottom: solid 1px rgb(110, 117, 124); width: 10px;" title="#">
                                            <i class="fa-solid fa-lg fa-arrow-down-1-9"></i>
                                        </th>
                                        <th class="fw-light bg-black text-white fs-6" style="border-bottom: solid 1px rgb(110, 117, 124); width: 100px;"  title="Hostname">
                                            <select class="btn btn-black fs-5 text-white fw-light" v-model="name_alias_ip_toggle">
                                                <option value="hostname">Hostname</option>
                                                <option value="alias">Alias</option>
                                                <option value="ip">IP Address</option>
                                            </select>
                                        </th>
                                        <th class="fw-light bg-black text-white fs-6" style="border-bottom: solid 1px rgb(110, 117, 124);"  title="Backup Status">
                                            <i class="fa-solid fa-lg fa-cloud"></i>
                                        </th>
                                        <th class="fw-light bg-black text-white fs-6" style="border-bottom: solid 1px rgb(110, 117, 124);"  title="Turn On/Off Device">
                                            <i class="fa-solid fa-lg fa-share-from-square"></i>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(d, i) in filteredDevices" v-bind:key="i+1"> <!-- Content Row -->
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                            <p class="text-white fs-6 mt-1">{{i+1}}</p>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50);">
                                            <p class="text-white fs-6 mt-1">{{d[name_alias_ip_toggle]}}</p>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                            <button class="btn" style="width: 60px;" :class="{'btn-danger': !d.backed_up, 'btn-kraken': d.backed_up}" title="Backup Status">
                                                <i class="fa-solid fa-xl" :class="{'fa-close': !d.backed_up, 'fa-check': d.backed_up}"></i>
                                            </button>
                                        </td>
                                        <td class="text-center bg-black" style="border-bottom: solid 1px rgb(50,50,50); width: 30px;">
                                            <button class="btn btn-kraken" style="width: 60px;" @click="setVisualizer(d,i)" :disabled="gettingDevices" :title="`View ${d.hostname} backups.`">
                                                <i class="fa-solid fa-xl fa-share-from-square"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="input-group flex-nowrap">
                        <div class="btn btn-kraken text-white fs-6" style="pointer-events: none; width: 6%;" :class="{'disabled-div': !active_visualizer}">
                            <i class="fa-solid fa-eye" :class="{'fa-fade': active_visualizer}"></i>
                        </div>
                        <input type="text" class="bg-dark rounded text-white text-center fs-6 border-0 me-1" style="pointer-events: none; width: 40%;" :value="selected_device.hostname" :class="{'disabled-div': !active_visualizer}" readonly>
                        <!-- Dates -->
                        <select class="bg-dark rounded text-white text-center fs-6 border-0 me-1" style="width: 30%;" v-model="backup_date" @change="getBackups" :class="{'disabled-div': !active_visualizer || gettingBackups}">
                            <option :value="null">Select a date...</option>
                            <option v-for="(dt, di) in dates" v-bind:key="di+1" :value="dt">{{dt}}</option>
                        </select>
                        <!-- Backup Types -->
                        <select class="bg-dark rounded text-white text-center fs-6 border-0 me-1" style="width: 30%;" v-model="selected_backup" :class="{'disabled-div': backups.length == 0 }">
                            <option :value="default_selected_backup">Select a backup...</option>
                            <option v-for="(bk, i) in backups" v-bind:key="i+1" :value="bk">{{bk.name}}</option>
                        </select>
                        <button v-if="!gettingBackups" class="btn btn-kraken fs-6 rounded" @click="generateTextFile" :class="{'disabled-div': backups.length == 0 || String(selected_backup.content).includes('File not found')}" title="Download as txt.">
                            <i class="fa-solid fa-xl fa-file-arrow-down"></i>
                        </button>
                        <button v-if="gettingBackups" class="btn btn-kraken fs-6 rounded" @click="generateTextFile" disabled>
                            <i class="fa-solid fa-xl fa-spinner fa-spin"></i>
                        </button>
                    </div>
                    <div class="input-group flex-nowrap mt-1"></div>
                    <div class="">
                        <textarea class="w-100 rounded bg-black" style="color: skyblue; height: 445px; resize: none;" :value="selected_backup.content" readonly></textarea>
                        <div>
                            <button class="btn btn-kraken fs-6 rounded" style="width: 100%;" @click="cleanBackupVisualizer" :class="{'disabled-div': !active_visualizer}">
                                Clear
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>

    <!-- Form to Generate the backup txt File -->
    <form :action="fileGenerationAction" method="GET" id="generateTxt" target="formware" style="display: none">
        <input type="text" v-model="selected_device.hostname" name="keyword">
        <input type="text" v-model="selected_backup.name" name="name">
        <textarea v-model="this.selected_backup.content" name="textContent"></textarea>
        <input type="text" name="unique" v-model="unique">
    </form>

    <!-- Form to Generate the backup txt File -->
    <form :action="backupsZipAction" method="GET" id="backupsZipForm" target="formware" style="display: none">
        <input type="text" name="unique" :value="unique">
    </form>

    <!-- Target of all the download forms-->
    <iframe name="formware" id="formware" frameborder="0" style="display: none;"></iframe>

    <!-- Summary -->
    <div class="p-2 rounded border-top border-info mt-2">
        <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-8">
                <div class="input-group flex-nowrap">
                    <!-- Summary Title -->
                    <div style="width: 15%;"></div>
                    <input class="btn text-white fw-light fs-5 rounded me-3" style="width: 120px;" type="text" value="Summary" readonly>
                    <!-- Last Backup -->
                    <input class="btn text-white fw-light fs-6 rounded me-3 mt-1" style="width: 250px;" type="text" :value="summary.lastBackup" title="Last Backup" readonly>
                    <!-- Total Backups -->
                    <button class="btn btn-kraken fs-6 rounded me-2" style="width: 50px;" title="Total Backups" readonly>
                        <i class="fa-solid fa-floppy-disk"></i>
                        {{summary.backups.total}}
                    </button>
                    <!-- Success Backups -->
                    <button class="btn btn-success fs-6 rounded me-2" style="width: 50px;" title="Success Backups" readonly>
                        <i class="fa-solid fa-check"></i>
                        {{summary.backups.success}}
                    </button>
                    <!-- Warning Backups -->
                    <button class="btn btn-warning fs-6 rounded me-2" style="width: 50px;" title="Warning Backups" readonly>
                        <i class="fa-solid fa-triangle-exclamation fa-shake"></i>
                        {{summary.backups.warning}}
                    </button>
                    <!-- Failed Backups -->
                    <button class="btn btn-danger fs-6 rounded me-2" style="width: 50px;" title="Failed Backups" readonly>
                        <i class="fa-solid fa-xl fa-xmark fa-beat-fade"></i>
                        {{summary.backups.failed}}
                    </button>
                    <!-- Refresh Summary -->
                    <button class="btn btn-kraken fs-6 rounded me-2" style="width: 50px;" title="Refresh summary" @click="getSummary">
                        <i class="fa-solid fa-arrows-rotate" :class="{'fa-spin': gettingSummary}"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// Import the component with the line below.
//import Visualizer from '@/components/apps-components/autobackups/Visualizer.vue'

import axios from "axios";

export default {
  name: 'Visualizer',
  components: {},
  data(){
    return {
        // General for the requests.
        site: null,
        stage: null,
        // Component Data
        unique: null,
        gettingSummary: false,
        summary: {
            lastBackup: "-",
            backups: {
            success: 0,
            warning: 0,
            failed: 0,
            total: 0
            }
        },
        backup_date: null,
        dates: [],
        searchKeyword: "",
        searchingBackup: false,
        selectedBackup: {name: null, content: null},
        activeBackupContent: "...",
        backupSearch: {
            keyword: "-",
            backups: []
        },
        // Backups
        backups: [],
        gettingBackups: false,
        // Backups Zip
        gettingBackupsZip: false,
        // Visualization
        vismode: "table",
        active_visualizer: false,
        active_download: false,
        name_alias_ip_toggle: "hostname",
        default_selected_device: { current_index: null, hostname: 'Select a device...', ip:null},
        selected_device: { current_index: null, hostname: 'Select a device...', ip: null},
        default_selected_backup: {name: null, content: null},
        selected_backup: {name: null, content: null},
        // Devices
        devices: [],
        gettingDevices: false,
        // Filtering
        searchWord: ""


    }
  },
  methods:{
    // Summary
    getSummary(){
      this.gettingSummary = true
      this.updatingSummary()
      const params = {}
      const dest = this.site + '/autobackups/visualizer/getSummary'
      axios
          .get(dest, {params})
          .then(rx => {
            this.summary = rx.data.data
            this.gettingSummary = false
          })
          .catch(error => {
              this.processErrorMessage(error)
              this.gettingSummary = false
          });
    },
    updatingSummary(){
        this.summary = {
            lastBackup: "Updating...",
            backups: {
                success: 0,
                warning: 0,
                failed: 0,
                total: 0
            }
        }
    },
    // Search Backup
    searchBackup(){
      if (this.searchKeyword == ""){
        alert("Empty search.")
        return
      }
      alert(this.searchKeyword + '/' +this.backup_date)
      this.searchingBackup = true
      this.backupSearch.backups = []
      this.activeBackupContent = "..."
      const params = { keyword: this.searchKeyword, date: this.backup_date }
      const dest = this.site + '/autobackups/visualizer/searchBackup'
      axios
          .post(dest, params)
          .then(rx => {
            this.backupSearch = rx.data.data
            this.searchingBackup = false
          })
          .catch(error => {
              this.processErrorMessage(error)
              this.searchingBackup = false
          });
    },
    clearSearch(){
        this.searchKeyword = ""
        this.selectedBackup = {name: null, content: ""}
        this.activeBackupContent = "..."
        this.backupSearch = {
            keyword: "-",
            backups: []
        }
    },
    viewBackup(_backup_type){
      this.selectedBackup = _backup_type
      this.activeBackupContent = _backup_type.content
    },
    generateTextFile(){
        this.setUnique()
        if (this.selected_backup.name == null){
            alert("Select a backup first.")
            return
        }
        if (this.selected_backup.content == ""){
            alert("Empty content.")
            return
        }
        // Generate file.
        console.log(this.selected_backup)
        const blob = new Blob([this.selected_backup.content], { type: "text/plain" });
        const alink = document.createElement("a");
        alink.href = URL.createObjectURL(blob);
        alink.download =`${this.selected_device.hostname}_${this.selected_backup.name}.txt`;
        alink.click();
        URL.revokeObjectURL(alink.href);


        //generateTxt.submit()
    },
    // Backups
    setVisualizer(_device, _current_index){
        // Cleaning
        this.cleanBackupVisualizer()
        // Get the dates.
        this.getBackupDates()
        // Set device.
        this.selected_device = _device
        this.selected_device.current_index = _current_index
        // Active visualizer.
        this.active_visualizer = true
    },
    getBackupDates(){
        this.backup_date = null
        this.gettingBackups = true
        const params = {}
        const dest = this.site + '/autobackups/visualizer/getBackupDates'
        axios
            .get(dest, {params})
            .then(rx => {
                this.dates = rx.data.data
                this.dates.sort()
                this.gettingBackups = false
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.gettingBackups = false
            });
    },
    getBackups(_device, _current_index){
        if (this.selected_device.ip == "" || this.selected_device.ip == null){
            alert("Invalid device.")
            return
        }
        this.backups = []
        this.resetObject(this.selected_backup, null)
        if (this.backup_date == null){    
            return
        }
        this.gettingBackups = true
        const params = { keyword: this.selected_device.ip, date: this.backup_date }
        const dest = this.site + '/autobackups/visualizer/searchBackup'
        axios
            .post(dest, params)
            .then(rx => {
                this.backups = rx.data.data.backups
                this.gettingBackups = false
                if (this.backups.length > 0){
                    this.active_download = true
                }
                else{
                    alert('Backups not found, try with a different date.')
                }
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.gettingBackups = false
                this.active_download = false
            });
    },
    cleanBackupVisualizer(){
        this.selected_device = this.default_selected_device
        this.selected_backup = this.default_selected_backup
        this.backups = []
        this.gettingBackups = false
        this.active_visualizer = false
        this.active_download = false
        this.backup_date = null
    },
    getBackupsZip(){
        if ( !confirm('Download all backups?') ){
            return
        }
        this.setUnique()
        backupsZipForm.submit()
    },
    setUnique(){
        var date = new Date();
        this.unique = date.getTime()
    },
    // Visualization
    setVismode(vis_mode){
        this.vismode = vis_mode
    },
    // Devices
    getDevices(){
        this.cleanBackupVisualizer()
        this.gettingDevices = true
        this.devices = []
        const params = {filter: 'all'}
        const dest = this.site + '/autobackups/visualizer/getDevices'
        axios
            .get(dest, {params})
            .then(rx => {
                // OK
                this.devices = rx.data.data.devices
                this.gettingDevices = false
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.gettingDevices = false
        });
    },

    // Misc
    capitalize(_string){
        if (_string == null){return ""}
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    resetObject(ob, val){
      Object.keys(ob).forEach(k => ob[k] = val);
    },

    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.data.errorMessage
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.errorMessage
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  created: function(){
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
    this.setUnique()
    this.getSummary()
    this.getDevices()
    this.getBackupDates()
    this.fileGenerationAction = `${this.site}/autobackups/visualizer/generateTextFile`
    this.backupsZipAction = `${this.site}/autobackups/visualizer/getBackupsZip`
  },
  computed: {
    filteredDevices(){
        if (this.searchWord == ''){
            return this.devices
        }
        this.searchWord = this.searchWord.toLowerCase()
        return this.devices.filter( device => String(device[this.name_alias_ip_toggle]).toLowerCase().includes( this.searchWord ) );
    }
  }
}
</script>

<style scoped>
  .section-button{
    background-color: Black;
    border: solid 2px Black;
    color: White;
  }
  .section-button:hover{
    color: rgb(72,167,238);
    border-bottom: solid 2px rgb(162, 200, 250);
  }

  .disabled-div{
    pointer-events: none;
    opacity: 0.5;
  }

   /* Table with static header */
  .tableFixHead {
      overflow-y: auto;
      overflow-x: hidden;
    }
  .tableFixHead thead th {
      position: sticky;
      top: 0;
      text-align: center;
      z-index: 1;
  }
  table {
      border-collapse: collapse;
      width: 100%;
  }
  th, td {
      padding: 8px 16px;
  }
  th {
      background: #eee;
  }

    .bg-input{
        background-color: rgb(7,13,15);
        color: white;
    }

    .temporal-disable{
        opacity: 0.5;
        pointer-events: none;
    }

    .btn-kraken{
        background-color: rgb(20, 63, 162);
        color: white;
        transition-duration: 0.5s;
    }
    .btn-kraken:hover{
        background-color: rgb(0, 17, 39);
        color: rgb(0, 211, 249);
    }

</style>
